import { GeneralFetch } from "./GeneralFetch";

async function obtenerOrder(orderHash){
    var datos = await GeneralFetch("GET", `/${orderHash}`);
    return datos;
}

export {obtenerOrder}